// make our action generators utility functions for ease of use. Practically there is no difference between
// this method and just calling dispatch({ type: '', payload: {} }) with the appropriate values
const onLevelButtonOutAction = payload => {
    return { type: 'LEVEL_BUTTON_OUT', payload };
};

export default onLevelButtonOutAction;


// WEBPACK FOOTER //
// ./src/actions/onLevelButtonOutAction.js